export { default as CoreComponent } from './CoreComponent';



// WEBPACK FOOTER //
// ./src/framework/component/index.js